import { getSeasonWeekIDByGameID } from '@shared/helpers';
import { Emojis, LocationCls, ValueCls } from 'app/constants';
import { setSelectedGame, setSelectedSeasonWeek } from 'app/slices/GamesSlice';
import { store } from 'app/store';

export type GameDetailsPayload = {
  gameId: string;
};

export const gameDetailsLoader = async ({ params }: any): Promise<GameDetailsPayload> => {
  const gameId = params.gameId;

  const msg = `${Emojis.eyes} %c gameDetailsLoader %c gameId %c ${gameId} %c`;
  console.log(msg, LocationCls, '', ValueCls, '');

  // Set the selected game
  store.dispatch(setSelectedGame(gameId));

  // Extract and set the season week from the gameID
  const seasonWeekID = getSeasonWeekIDByGameID(gameId);
  store.dispatch(setSelectedSeasonWeek(seasonWeekID));

  return { gameId };
};
